import { render, staticRenderFns } from "./CmgCheckoutDeliveryInfo.vue?vue&type=template&id=36d83a10&scoped=true&lang=pug&"
import script from "./cmg-checkout-delivery-info.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-delivery-info.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutDeliveryInfo.vue?vue&type=style&index=0&id=36d83a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d83a10",
  null
  
)

export default component.exports